export default {
    active: true,
    seed: 17,
    skyType: "gradient",
    skyColor: "#87faf4",
    horizonColor: "#b34093",
    lighting: "distant",
    lightPosition: { x: -0.72, y: 0.53, z: 0.97 },
    fog: 0.8,
    flatShading: false,
    playArea: 1,
    ground: "hills",
    groundYScale: 20,
    groundTexture: "checkerboard",
    groundColor: "#b34093",
    groundColor2: "#c050a2",
    dressing: "mushrooms",
    dressingAmount: 300,
    dressingColor: "#3cf7ed",
    dressingScale: 0.2,
    dressingVariance: { x: 0.2, y: 0.2, z: 0.2 },
    dressingUniformScale: true,
    dressingOnPlayArea: 1,
    grid: "none",
    gridColor: "#239893",
    shadow: false,
};
